import { render, staticRenderFns } from "./message-dialog.vue?vue&type=template&id=9787347e&scoped=true"
import script from "./message-dialog.vue?vue&type=script&lang=js"
export * from "./message-dialog.vue?vue&type=script&lang=js"
import style0 from "./message-dialog.vue?vue&type=style&index=0&id=9787347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9787347e",
  null
  
)

export default component.exports